import { Component, ViewChild } from "@angular/core";
import { ViewController, PopoverController, LoadingController, AlertController, NavController, App } from "ionic-angular";
import { RecaptchaComponent } from "ng-recaptcha";
import { C } from "../../../utils/constants";
import { TypeServices } from "../../../utils/types";
import { UserProvider } from "../../../providers/user";
import { ReservesProvider } from "../../../providers/reserves";

@Component({
    selector: 'popover-template',
    templateUrl: './popover-template.html'
})

export class PopoverTemplateComponent {
    @ViewChild(RecaptchaComponent) captcha: RecaptchaComponent;

    public title: string = '';
    public dotItems: Array<any> = [];
    private selectedItem: any;
    private loaderInstance: any;
    private popoverAction: any;
    private recaptchaSecretKey: string = C.SITE_RC_SECRET_KEY;
    private currentTab: any;
    public nav: NavController;
    public firebasePlugin: any;

    constructor(
        private app: App,
        private viewCtrl: ViewController,
        private popoverCtrl: PopoverController,
        private loadingCtrl: LoadingController,
        private user_m: UserProvider,
        private reserves_m: ReservesProvider,
        private alertCtrl: AlertController,
        private navCtrl: NavController,
        ) {
            this.firebasePlugin = (<any>window).FirebasePlugin;
        }

    ngOnInit() {
        let recieved = this.viewCtrl.data;
        this.popoverAction = recieved.data.action;
        this.dotItems = recieved.data.items;
        this.title = recieved.data.title;
        this.currentTab = {
            sequency: recieved.data.sequency,
        }
        this.nav = recieved.nav;
    }

    openItem(item) {
        item.callback();
    }

    public openCaptcha(item) {
        this.selectedItem = item;

        this.loaderInstance = this.loadingCtrl.create({
            content: "Aguarde...",
            spinner: 'crescent',
            dismissOnPageChange: true
        });
        this.loaderInstance.present();

        this.captcha.execute();
    }

    public async resolvedCaptcha(token) {
        if (token) {
            this.captcha.reset();

            this.user_m.verify(this.recaptchaSecretKey, token)
                .then((response: any) => {
                    this.loaderInstance.dismiss();
                    this.saveReserve(this.selectedItem);
                }).catch((error) => {
                    console.log(error);
                    this.loaderInstance.dismiss();
                    if (!error.success) {
                        let alert = this.alertCtrl.create({
                            title: 'Ops!',
                            message: 'Teste inválido, tente novamente!',
                            buttons: ['ok']
                        })
                        alert.present();
                    } else {
                        let alert = this.alertCtrl.create({
                            title: 'Ops!',
                            message: 'Erro desconhecido!',
                            buttons: ['ok']
                        })
                        alert.present();
                        console.log(error);
                    }
                });
        } else {
            console.log("RESETED");
        }
    }

    public saveReserve (item){
        let confirmation = this.alertCtrl.create({
            title: 'Confirmar Reserva?',
            message: 'Deseja realmente efetuar a reserva do <b>' + item.name + '</b>?',
            buttons: [
                {
                    text: 'Cancelar',
                    role: 'cancel'
                },
                {
                    text: 'Confirmar',
                    role: 'cancel',
                    handler: () => {

                        let alert:any,
                            loader:any;

                        loader = this.loadingCtrl.create({
                            content: "Aguarde...",
                            spinner: 'crescent',
                            dismissOnPageChange: true
                        });
                        loader.present();

                        this.reserves_m.reserveKiosk(item.id, {
                            sequency: this.currentTab.sequency
                        }).then((data:any) => {
                            loader.dismiss();

                            let eventParams = { quiosque_id: item.id, quiosque_nome: item.title };
                            console.log("Evento Firebase (reservas_quiosque_mapa_reservado)", eventParams);
                            // this.firebasePlugin.logEvent("reservas_quiosque_mapa_reservado", eventParams);

                            alert = this.alertCtrl.create({
                                title: 'Sucesso!',
                                message: data,
                                enableBackdropDismiss: false,
                                buttons: [
                                    {
                                        text: 'Fechar',
                                        role: 'cancel',
                                        handler: () => {
                                            this.viewCtrl.onDidDismiss(() => {
                                                this.nav.setRoot('MinhasReservasPage', { type: TypeServices.Quiosque, sequency: this.currentTab.sequency }, { animate: true, direction: 'forward' });
                                            })
                                            this.viewCtrl.dismiss();
                                        }
                                    }
                                ]
                            });
                            alert.present();
                        }).catch((error:any) => {
                            let message:string = typeof error.message == 'undefined' ? error : error.message;
                            if (typeof error.kiosk != 'undefined'){
                                item = Object.assign(item, error.kiosk);
                            }
                            loader.dismiss();
                            alert = this.alertCtrl.create({
                                title: 'Ops!',
                                message: message,
                                enableBackdropDismiss: false,
                                buttons: [
                                    {
                                        text: 'Fechar',
                                        role: 'cancel'
                                    }
                                ]
                            });
                            alert.present();
                        });
                    }
                }
            ]
        });
        confirmation.present();
    }

    public changeTab(tab) {
        this.currentTab = tab;
    }
}



// WEBPACK FOOTER //
// ./src/components/mapa/popover-template/popover-template.ts